import apiClient from "../../../utils/interceptor";
import {
  ApiResponse,
  MachineVersionData,
  CreateMachineVersionParams,
  CreateMachineVersionResponse,
  UpdateMachineVersionParams,
} from "./interface";
import { API_URLS } from "../../../constants";

// Helper to get auth token
const getAuthToken = (): string | null => {
  return localStorage.getItem("auth_token");
};

// Get all machine versions by machine ID
export const getVersionsByMachineId = async (
  machineId: string
): Promise<ApiResponse<MachineVersionData[]>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.get<ApiResponse<MachineVersionData[]>>(
      `${API_URLS.MACHINE_VERSION.GET_VERSIONS}/${machineId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching machine versions:", error);
    throw error;
  }
};

// Create a new machine version
export const createMachineVersion = async (
  params: CreateMachineVersionParams
): Promise<ApiResponse<CreateMachineVersionResponse>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.post<ApiResponse<CreateMachineVersionResponse>>(
      API_URLS.MACHINE_VERSION.CREATE_VERSION,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating machine version:", error);
    throw error;
  }
};

export const updateMachineVersion = async (
    machineVersionData: UpdateMachineVersionParams
): Promise<ApiResponse<null>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.patch<ApiResponse<null>>(
            API_URLS.MACHINE_VERSION.UPDATE_VERSION,
            machineVersionData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error updating machine version:", error);
        throw error;
    }
};

// Delete a machine version
export const deleteMachineVersion = async (
  machineVersionId: string
): Promise<ApiResponse<null>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.delete<ApiResponse<null>>(
      API_URLS.MACHINE_VERSION.DELETE_VERSION,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: { machine_version_id: machineVersionId },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting machine version:", error);
    throw error;
  }
};